import { createAction } from 'redux-act';
// add Position action
const addPositionRequest = createAction('ADD_POSITION_REQUEST', data => data);
const addPositionSuccess = createAction('ADD_POSITION_SUCCESS', data => data);
const addPositionError = createAction('ADD_POSITION_ERROR');

// get Position action
const getAllPositionRequest = createAction('GET_ALL_POSITION_REQUEST', data => data);
const getAllPositionSuccess = createAction('GET_ALL_POSITION_SUCCESS', data => data);
const getAllPositionError = createAction('GET_ALL_POSITION_ERROR');

// get Position By Department Designation action
const getPositionsByDepartmentDesignationRequest = createAction('GET_POSITION_BY_DEPARTMENT_DESIGNATION_REQUEST', data => data);
const getPositionsByDepartmentDesignationSuccess = createAction('GET_POSITION_BY_DEPARTMENT_DESIGNATION_SUCCESS', data => data);
const getPositionsByDepartmentDesignationError = createAction('GET_POSITION_BY_DEPARTMENT_DESIGNATION_ERROR');


// Update Position action
const updatePositionRequest = createAction('Update_POSITION_REQUEST', data => data);
const updatePositionSuccess = createAction('Update_POSITION_SUCCESS', data => data);
const updatePositionError = createAction('Update_POSITION_ERROR');

// Delete Position action
const deletePositionRequest = createAction('Delete_POSITION_REQUEST', data => data);
const deletePositionSuccess = createAction('Delete_POSITION_SUCCESS', data => data);
const deletePositionError = createAction('Delete_POSITION_ERROR');

// clear existing Position action
const handleClearPositionStore = createAction('HANDLE_CLEAR_POSITION_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addPositionRequest,
    addPositionSuccess,
    addPositionError,

    getAllPositionRequest,
    getAllPositionSuccess,
    getAllPositionError,

    getPositionsByDepartmentDesignationRequest,
    getPositionsByDepartmentDesignationSuccess,
    getPositionsByDepartmentDesignationError,

    updatePositionRequest,
    updatePositionSuccess,
    updatePositionError,

    deletePositionRequest,
    deletePositionSuccess,
    deletePositionError,
    
    handleClearPositionStore,
    // toastMsgAction,
    
}